import * as React from "react";
import { createContext, useState, useContext } from "react";

const DataContext = createContext();

export const useEmailDataContext = () => useContext(DataContext);

export const EmailDataContextProvider = ({ children }) => {
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const [presentationsObject, setPresentationsObject] = useState([]);
  const [documentsObject, setDocumentsObject] = useState([]);
  const [newsObject, setNewsObject] = useState([]);
  const [webformsObject, setWebformsObject] = useState([]);
  const [eventsObject, setEventsObject] = useState([]);
  const [contentTypeSelected, setContentTypeSelected] = useState("presentation");
  const [subscriber, setSubscriber] = useState(false);

  return (
    <DataContext.Provider
      value={{
        selectedLanguage,
        setSelectedLanguage,
        selectedBrand,
        setSelectedBrand,
        selectedTemplate,
        setSelectedTemplate,
        presentationsObject,
        setPresentationsObject,
        documentsObject,
        setDocumentsObject,
        newsObject,
        setNewsObject,
        webformsObject,
        setWebformsObject,
        eventsObject,
        setEventsObject,
        contentTypeSelected,
        setContentTypeSelected,
        subscriber,
        setSubscriber,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};
